<template>
  <v-tooltip left>
    <template #activator="{ on }">
      <v-btn color="error" fab dark fixed bottom right v-on="{ ...on, ...$listeners }">
        <v-icon>error_outline</v-icon>
      </v-btn>
    </template>
    <span>{{ value }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'FabError',
  props: {
    type: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: 'You have errors',
    },
  },
}
</script>
